"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = require("react");

var _ramda = require("ramda");

/**
 * Hook that returns an array and setter that add/removes items
 * @param {boolean} allowMultiple whether to append items that do not exist in the array
 * @returns {[items, onItemClick]} [state, setter]
 */
var useToggleSet = function useToggleSet(initialArray, allowMultiple) {
  if (initialArray === void 0) {
    initialArray = [];
  }

  if (allowMultiple === void 0) {
    allowMultiple = true;
  }

  var _useState = (0, _react.useState)(initialArray),
      items = _useState[0],
      updateItems = _useState[1];

  var onItemClick = (0, _react.useCallback)(function (item) {
    var index = (0, _ramda.indexOf)(item, items);

    if (index > -1) {
      updateItems((0, _ramda.remove)(index, 1, items));
    } else if (allowMultiple) {
      updateItems((0, _ramda.append)(item, items));
    } else {
      updateItems([item]);
    }
  }, [allowMultiple, items]);
  return [items, onItemClick];
};

var _default = useToggleSet;
exports["default"] = _default;